import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const HourglassOutlined = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function HourglassOutlined({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <path fillRule="evenodd" clipRule="evenodd" d="M19.5 5c0-2.21-1.79-4-4-4h-7c-2.21 0-4 1.79-4 4 0 3.44 2.63 5.41 5.42 7-2.79 1.59-5.42 3.56-5.42 7 0 2.21 1.79 4 4 4h7c2.21 0 4-1.79 4-4 0-3.44-2.63-5.41-5.42-7 2.79-1.59 5.42-3.56 5.42-7Zm-11-2h7c1.1 0 2 .9 2 2 0 .75-.2 1.41-.54 2H7.04c-.34-.59-.54-1.25-.54-2 0-1.1.9-2 2-2Zm9 16c0 1.1-.9 2-2 2h-7c-1.1 0-2-.9-2-2 0-2.75 2.61-4.3 5.5-5.86 2.89 1.56 5.5 3.11 5.5 5.86Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default HourglassOutlined;